import React, { useMemo } from 'react';
import { Mafs, Coordinates, Plot, Theme } from 'mafs';
import * as math from 'mathjs';

export const VectorField = ({ config, variables }) => {
    const fieldXStr = config.fieldX || "y";
    const fieldYStr = config.fieldY || "-x";
    const step = config.step ?? 0.5;

    // 1. Compile Once (Safety)
    const { fx, fy } = useMemo(() => {
        try {
            return {
                fx: math.compile(fieldXStr),
                fy: math.compile(fieldYStr)
            };
        } catch (e) {
            console.error("VectorField Compile Error", e);
            // Fallback to zero field
            const zero = math.compile("0");
            return { fx: zero, fy: zero };
        }
    }, [fieldXStr, fieldYStr]);

    return (
        <Mafs viewBox={{ x: [-5, 5], y: [-5, 5] }} pan={false}>
            <Coordinates.Cartesian />
            <Plot.VectorField
                xy={([x, y]) => {
                    try {
                        const scope = { x, y, ...variables };
                        return [fx.evaluate(scope), fy.evaluate(scope)];
                    } catch (e) {
                        return [0, 0];
                    }
                }}
                step={step}
                color={Theme.teal}
            />
        </Mafs>
    );
};